<script setup>
import { Head, router } from "@inertiajs/vue3";

import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import VAlert from "@/Shared/VAlert.vue";
import Swal from "sweetalert2";

let props = defineProps({
    list: Array,
    runUrl: String,
});

const breadcrumbs = [
    {
        url: "#",
        label: "Seeder List",
    },
];

const runAction = async (value) => {
    const result = await Swal.fire({
        icon: "warning",
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, run seeder!",
    });

    if (!result.isConfirmed) {
        return false;
    }

    router.post(props.runUrl, {
        class_name: value.className,
    });
};
</script>

<template>
    <Head>
        <title>List Seeder</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <VAlert />
        <div class="card">
            <div class="card-body">
                <div class="list-group">
                    <a
                        href="#"
                        v-for="seed in list"
                        class="list-group-item list-group-item-action"
                        aria-current="true"
                        @click="runAction(seed)"
                    >
                        <div class="d-flex w-100 justify-content-between">
                            <h5 class="mb-1">{{ seed.fileName }}</h5>
                            <small>{{ seed.humantime }}</small>
                        </div>
                        <!-- <p class="mb-1">
                            Some placeholder content in a paragraph.
                        </p> -->
                        <small>Database\Seeders\{{ seed.className }}</small>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
